// SubMenuScroller.ts
export function SubMenuScroller(container: HTMLElement): void {
    let pos = { top: 0, left: 0, x: 0, y: 0 };
    let clickTimer: ReturnType<typeof setTimeout> | null = null;

    const mouseMoveHandler = (e: MouseEvent): void => {
        const dx = e.clientX - pos.x;
        const dy = e.clientY - pos.y;

        container.scrollTop = pos.top - dy;
        container.scrollLeft = pos.left - dx;
    };

    const mouseDownHandler = (e: MouseEvent): void => {
        if (clickTimer) clearTimeout(clickTimer);

        clickTimer = setTimeout(() => {
            container.classList.add("moving");
            container.style.cursor = "grabbing";
            container.style.userSelect = "auto";

            pos = {
                left: container.scrollLeft,
                top: container.scrollTop,
                x: e.clientX,
                y: e.clientY,
            };

            document.addEventListener("mousemove", mouseMoveHandler);
            document.addEventListener("mouseup", mouseUpHandler);

            container.querySelectorAll<HTMLAnchorElement>("a").forEach((link) => {
                link.style.pointerEvents = "auto";
            });
        }, 100);
    };

    const mouseUpHandler = (): void => {
        if (clickTimer) clearTimeout(clickTimer);

        document.removeEventListener("mousemove", mouseMoveHandler);
        document.removeEventListener("mouseup", mouseUpHandler);

        container.classList.remove("moving");
        container.style.cursor = "grab";
        container.style.removeProperty("user-select");

        container.querySelectorAll<HTMLAnchorElement>("a").forEach((link) => {
            link.style.pointerEvents = "auto";
        });
    };

    container.addEventListener("mousedown", mouseDownHandler);
}
